import { DesignTheme, ThemeId } from '../types'
import { defaultDarkTheme, defaultTheme } from './default'
import { vividDarkTheme, vividTheme } from './vivid'
import { spectrumDarkTheme, spectrumTheme } from './spectrum'

/** Registry — add image-derived themes here */
export const themes: Record<ThemeId, DesignTheme> = {
  [defaultTheme.id]: defaultTheme,
  [defaultDarkTheme.id]: defaultDarkTheme,
  [vividTheme.id]: vividTheme,
  [vividDarkTheme.id]: vividDarkTheme,
  [spectrumTheme.id]: spectrumTheme,
  [spectrumDarkTheme.id]: spectrumDarkTheme,
}

/** Spectrum is the current site-wide default theme pack */
export const DEFAULT_THEME_ID: ThemeId = spectrumTheme.id

export function getTheme(id: ThemeId): DesignTheme {
  return themes[id] ?? defaultTheme
}

export function hasTheme(id: ThemeId): boolean {
  return Boolean(themes[id])
}

export function listThemes(): DesignTheme[] {
  return Object.values(themes)
}

export { defaultTheme, defaultDarkTheme }
export { vividTheme, vividDarkTheme }
export { spectrumTheme, spectrumDarkTheme }
